// src/components/attendance/AttendanceDetailsModal.jsx

import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: 400 },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  borderRadius: 1,
  maxHeight: '70vh',
  overflowY: 'auto',
};

const AttendanceDetailsModal = ({
  open,
  onClose,
  entityName, // Dynamic for Student or Employee
  dailyAttendance,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="attendance-details-title"
      aria-describedby="attendance-details-description"
    >
      <Box sx={modalStyle}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography id="attendance-details-title" variant="h6" component="h2" noWrap>
            {entityName}'s Attendance
          </Typography>
          <IconButton onClick={onClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Box>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>Date</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(dailyAttendance).map(([date, status]) => (
              <TableRow key={date}>
                <TableCell>{new Date(date).toLocaleDateString()}</TableCell>
                <TableCell>{status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Modal>
  );
};

AttendanceDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  entityName: PropTypes.string.isRequired, // Dynamic title
  dailyAttendance: PropTypes.object.isRequired,
};

export default AttendanceDetailsModal;